<template lang="pug">
.card.no-decoration.tooltip.tooltip-wrap.tooltip-bottom(
  :data-tooltip="cadastro.endereco | enderecoFormatted"
)
  .card-body
    .columns
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.tipo' | tModel",
          :text="`enums.db.enum_cadastro_tipo.${cadastro.tipo}` | translate"
        )
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.situacao' | tModel",
          :text="cadastro.situacao.descricao"
        )
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.numero' | tModel",
          :text="cadastro.numero"
        )
      .column.col-4.col-sm-6
        text-output(:label="'cadastro.zona' | tModel", :text="cadastro.zona")
      .column.col-4.col-sm-6
        text-output(
          :label="'cadastro.quadra' | tModel",
          :text="cadastro.quadra"
        )
      .column.col-4.col-sm-6
        text-output(:label="'cadastro.lote' | tModel", :text="cadastro.lote")
  .card-footer.text-right
    router-link.btn.btn-link(
      :to="{ name: 'app.carnes.carne', params: { id: cadastro.id } }"
    )
      i.fa.fa-barcode
      span Gerar carnê
</template>

<script>
export default {
  props: { cadastro: { type: Object, required: true } },
};
</script>
